// **********************************************************
// Open Modal
// **********************************************************

// **********************************************************
// Open More Modal
// **********************************************************

attachEvent('.table__more-link', 'click', (ev) => {
  const parentSectionEle = ev.target.closest('section');
  const parentElem = ev.target.closest('.table__data');
  const moreModal = parentElem.querySelector('.more-modal');

  if (moreModal) {
    moreModal.classList.add('is-open-modal');

    if (parentSectionEle) {
      parentSectionEle.classList.add('is-open-table-modal');
    }

    ev.preventDefault();
  }
});
